import React from 'react';
import { Card, Tag, Button, Space, Typography } from 'antd';
import { DeleteOutlined, GroupOutlined } from '@ant-design/icons';

const { Text } = Typography;

const GroupByCard = ({ groupBy, onRemove }) => {
  const getSortIcon = (direction) => {
    return direction === 'ASC' ? '↑' : '↓';
  };

  const getSortColor = (direction) => {
    return direction === 'ASC' ? 'green' : 'red';
  };

  return (
    <Card
      size="small"
      style={{
        border: '1px solid #ffd591',
        backgroundColor: '#fff7e6'
      }}
      bodyStyle={{ padding: '12px' }}
    >
      <Space direction="vertical" size="small" style={{ width: '100%' }}>
        <Space align="center" style={{ width: '100%', justifyContent: 'space-between' }}>
          <Space align="center">
            <GroupOutlined style={{ color: '#fa8c16' }} />
            <Text strong style={{ fontSize: '14px', color: '#fa8c16' }}>
              {groupBy.alias || groupBy.field}
            </Text>
          </Space>
          <Button
            type="text"
            size="small"
            icon={<DeleteOutlined />}
            onClick={onRemove}
            danger
            style={{ padding: '2px' }}
          />
        </Space>

        <Space size="small" wrap>
          <Tag color="orange">
            Field: {groupBy.field}
          </Tag>
          {groupBy.sortDirection && (
            <Tag color={getSortColor(groupBy.sortDirection)}>
              {getSortIcon(groupBy.sortDirection)} {groupBy.sortDirection}
            </Tag>
          )}
        </Space>

        {groupBy.alias && groupBy.alias !== groupBy.field && (
          <Text type="secondary" style={{ fontSize: '12px' }}>
            Alias: {groupBy.alias}
          </Text>
        )}
      </Space>
    </Card>
  );
};

export default GroupByCard;